import React, { useState, useCallback, useEffect, createContext, useContext } from "react";
import { getCollateralKey, CollateralsKey } from "@liquity/lib-ethers";
import { useLiquity } from "./LiquityContext";

type AppStateContextType = {
  currentAssetAddress: string | undefined;
  currentSpAddress: string | undefined;
  currentCollateralKey: CollateralsKey | undefined;
  updateAssetAddress: (assetAddress: string | undefined) => void;
  updateSpAddress: (spAddress: string | undefined) => void;
};

export const AppStateContext = createContext<AppStateContextType | null>(null);

export const AppStateProvider: React.FC = props => {
  const { children } = props;
  const [currentAssetAddress, setCurrentAssetAddress] = useState<string | undefined>(undefined);
  const [currentSpAddress, setCurrentSpAddress] = useState<string | undefined>(undefined);
  const [currentCollateralKey, setCurrentCollateralKey] = useState<CollateralsKey | undefined>(undefined);
  const { liquity: { connection } } = useLiquity()

  const updateAssetAddress = useCallback((assetAddress: string | undefined) => {
    const collateralKey = getCollateralKey(assetAddress, connection);
    setCurrentAssetAddress(assetAddress);
    setCurrentCollateralKey(collateralKey);
    setCurrentSpAddress(undefined);
  }, [connection]);

  const updateSpAddress = useCallback((spAddress: string | undefined) => {
    const collateralKey = getCollateralKey(spAddress, connection);
    setCurrentSpAddress(spAddress);
    setCurrentCollateralKey(collateralKey);
    setCurrentAssetAddress(undefined);
  }, [connection]);

  const provider = {
    currentAssetAddress,
    currentSpAddress,
    currentCollateralKey,
    updateAssetAddress,
    updateSpAddress
  };
  return <AppStateContext.Provider value={provider}>{children}</AppStateContext.Provider>;
};

export const useAppState = (): AppStateContextType => {
  const context: AppStateContextType | null = useContext(AppStateContext);

  if (context === null) {
    throw new Error("You must add a <AppStateProvider> into the React tree");
  }

  return context;
};
